import React from 'react';
import Logger, {LOG_LEVELS} from '../../../utils/logger';
import ReadOnlyWrapper from '../../authorization/ReadOnlyWrapper';
import _ from 'lodash';

const log = new Logger('NumberField', LOG_LEVELS.DEBUG);

const NumberField = (props) => {
    log.debug('render(): ', props);    
    let {
        name, 
        value, 
        title='', 
        decimalPlaces, 
        defaultValue, 
        onChange, 
        isRational=false,
        extraProps={}
    } = props;
    let eleRef;
    onChange = typeof onChange !== 'function' ? ()=>{} : onChange;
    let onBlur = (event) => {
        //Format float values in case of decimal places is specified
        if(eleRef && Number.isInteger(decimalPlaces)) {
            let floatValue = parseFloat(value);
            decimalPlaces = decimalPlaces > 10 ? 10 : decimalPlaces;
            eleRef.value = Number.isNaN(floatValue) ? '': floatValue.toFixed(decimalPlaces);
            log.debug('Fromatted Value: ', eleRef.value);
            onChange(event);
        }
        if(eleRef && defaultValue !== undefined) {
            eleRef.value = !_.isEmpty(value) ? value : defaultValue;
            onChange(event);
        }
    };
    if(isRational) {
        //Replace all non-digits except dot(.) with nothing
        value = `${value}`.replace(/[^\d.-]/, '');
    } else {
        //Replace all non-digits with nothing
        value = `${value}`.replace(/\D+/g, '');
    }
    log.debug('defaultValue: ', defaultValue);
    log.debug('value: ', value);    
    return (
        <ReadOnlyWrapper>
            <div>
               <input defaultValue={defaultValue} ref={ el => eleRef = el } name={name} type="text" value={value} title={title} onChange={onChange} onBlur={onBlur} {...extraProps} />
            </div>
        </ReadOnlyWrapper>
    );
}

export default NumberField;
